import React from 'react';
import { Route } from 'react-router';
import { Redirect, Switch } from 'react-router-dom';

// Routes
import All from './routes/all';

export default function () {
    return(
        <div>
            <Switch>
                <Route path='/leads/all' component={() => <All />} />
                <Route exact path='/leads' component={() => <Redirect to={`/leads/all`} />} />
            </Switch>
        </div>
    )
}